<template>
  <generic-message-page :logo="parsePublicAssetsPath(Logo)">
    <slot>{{ $t('errors.generic') }}</slot>
  </generic-message-page>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue';
import Logo from '@/assets/error_page.svg';
import parsePublicAssetsPath from '@/utils/parsePublicAssetsPath';
import GenericMessagePage from './GenericMessagePage.vue';

onBeforeMount(() => {
  window.prerender?.internalServerError();
});
</script>
